import { TwoWaySchedule } from './TwoWaySchedule';
export default TwoWaySchedule;
